import { PeriodicTaskList } from './PeriodicTaskList';

export const list = PeriodicTaskList;
